export const ROOT_COMPONENT_ID = 'events-members-root'

export const EXPERIMENTS_SCOPE = 'wix-events-ui'
